import * as React from 'react';
import { Create, SimpleForm } from 'react-admin';
import { useFailureNotify } from '../../../hooks';
import Form from './Form';

export default props => {
  const notify = useFailureNotify();
  const { basePath } = props;

  return (
    <Create onFailure={notify} {...props}>
      <SimpleForm redirect={basePath}>
        <Form />
      </SimpleForm>
    </Create>
  );
};
